import type React from 'react';

import { Button } from '@xing-com/button';
import { IconArrowDown } from '@xing-com/icons';

import type {
  generateUrlTrackingParamsType,
  groupType,
  onTipsAndTricksButtonClickType,
  setOpenExtendersType,
} from '../../../types';

import { Styled } from './styles';

export type FeaturesTableActionsProps = {
  hideTipsAndTricks?: boolean;
  group?: groupType;
  groupIndex: number;
  tabIndex: number;
  onTipsAndTricksButtonClick: onTipsAndTricksButtonClickType;
  generateUrlTrackingParams?: generateUrlTrackingParamsType;
  openExtenders: Record<string, unknown>;
  setOpenExtenders: setOpenExtendersType;
};

export const FeaturesTableActions: React.FC<FeaturesTableActionsProps> = ({
  hideTipsAndTricks,
  group,
  groupIndex,
  tabIndex,
  generateUrlTrackingParams,
  openExtenders,
  setOpenExtenders,
  onTipsAndTricksButtonClick,
}) => {
  const hasFeatureUrl = group?.featureUrl?.text || null;
  const hasTipsAndTricks =
    (group?.tipsAndTricks && group.tipsAndTricks[0] && !hideTipsAndTricks) ||
    null;

  const showActions = hasFeatureUrl || hasTipsAndTricks;

  if (!showActions) {
    return null;
  }

  return (
    <Styled.FeatureActions>
      {group?.featureUrl?.text && (
        <Button
          variant="tertiary"
          size="small"
          sizeConfined="medium"
          target="_parent"
          // @ts-expect-error FIXME
          href={
            generateUrlTrackingParams
              ? generateUrlTrackingParams(
                  group?.featureUrl?.url || '',
                  tabIndex,
                  'featureUrl'
                )
              : group?.featureUrl?.url
          }
          data-testid={`table-action-1-tab-${tabIndex}-group-${groupIndex}`}
        >
          {group?.featureUrl?.text}
        </Button>
      )}
      {group?.tipsAndTricks && group.tipsAndTricks[0] && !hideTipsAndTricks && (
        <Button
          variant="tertiary"
          size="small"
          sizeConfined="medium"
          icon={IconArrowDown}
          onClick={() => {
            if (onTipsAndTricksButtonClick) {
              onTipsAndTricksButtonClick(
                !openExtenders[group.header || ''],
                tabIndex,
                groupIndex
              );

              setOpenExtenders({
                ...openExtenders,
                [group.header || '']: !openExtenders[group.header || ''],
              });
            }
          }}
          data-testid={`table-action-2-tab-${tabIndex}-group-${groupIndex}`}
        >
          {group.tipsAndTricks[0].text}
        </Button>
      )}
    </Styled.FeatureActions>
  );
};
